import React, { ReactElement } from "react";
import { Nullable } from "../../types/custom/Nullable";

export default function ErrorPage(isSessionError: boolean, errorMsg: Nullable<string>): ReactElement {
  return (
    <div>
      {errorMsg && <p className="paddingLeftFive">{errorMsg}</p>}
      <p className="paddingLeftFive">
        {!isSessionError ? errorMsg ? "Internal Communication Error. Please contact Colonial Life Support." : "Please validate the errors" : "Session may have expired. Please refresh your browser"}
      </p>
    </div>
  );
}
